import {Component} from '@angular/core';

@Component({
  selector: 'pt-widget-footer',
  template: `
    <div class='widget-footer'></div>
  `,
  styles: [`
    .widget-footer {
      width: 100%;
      height: 30px;
    }
  `]
})
export class WidgetFooterComponent {

}
